const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['header_content', [this, 'block_header_content']],
                    ['heading_content', [this, 'block_heading_content']],
                    ['author_title', [this, 'block_author_title']],
                    ['reply_form_hidden_inputs', [this, 'block_reply_form_hidden_inputs']],
                    ['reply_form', [this, 'block_reply_form']],
                    ['replies', [this, 'block_replies']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`_heading_depth`] = this.env.getFunction('min').traceableCallable(1, this.source)(...[(((context.has(`heading_depth`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`heading_depth`) ? context.get(`heading_depth`) : null), 3])) : (3)), 6]);
                this.echo(`
`);
                context.proxy[`_comment_modifiers`] = ``;
                if ( !this.env.getTest('empty').traceableCallable(4, this.source)(...[this.traceableMethod(this.getAttribute, 4, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `children`, new Map([]), `any`, false, false, false)])) {
                    this.echo(`  `);
                    context.proxy[`_comment_modifiers`] = ((context.has(`_comment_modifiers`) ? context.get(`_comment_modifiers`) : null) + ` c-comment--thread`);
                }
                this.echo(`
`);
                if ((context.has(`allow_replies`) ? context.get(`allow_replies`) : null)) {
                    this.echo(`  `);
                    context.proxy[`_comment_modifiers`] = ((context.has(`_comment_modifiers`) ? context.get(`_comment_modifiers`) : null) + ` js-comment-with-reply-form`);
                }
                this.echo(`
<article
  class="c-comment `);
                this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (context.has(`_comment_modifiers`) ? context.get(`_comment_modifiers`) : null), `html`, null, true]));
                this.echo(`"
  id="comment-`);
                this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 14, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `ID`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`"
  aria-labelledby="comment-heading-`);
                this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 15, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `ID`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`"
>
  <header class="c-comment__header">
    `);
                this.traceableDisplayBlock(18, this.source)('header_content', context.clone(), blocks);
                this.echo(`  </header>
  <div class="c-comment__object">
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, this.traceableMethod(this.getAttribute, 34, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `avatar`, new Map([]), `any`, false, false, false)], [`size`, `full`]]), false, false, 33));
                this.echo(`  </div>
  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, 38, 120), new Map([[`class`, `c-comment__content o-rhythm--condensed`]]), true, false, 38));
                this.echo(`  <footer class="c-comment__footer">
    <div class="c-comment__meta">
      <div class="c-comment__meta-detail">
        <a class="c-comment__meta-link"
          href="`);
                this.echo(this.env.getFilter('escape').traceableCallable(54, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 54, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`">
          <span class="c-comment__meta-icon">
            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `link`], [`inline`, true]]), false, false, 56));
                this.echo(`          </span>
          <span class="u-hidden-visually">
            Permalink to `);
                this.echo(this.env.getFilter('escape').traceableCallable(62, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 62, this.source)(this.env, this.traceableMethod(this.getAttribute, 62, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `author`, new Map([]), `any`, false, false, false), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`’s
          </span>
          <time datetime="`);
                this.echo(this.env.getFilter('escape').traceableCallable(64, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(64, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 64, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `date`, new Map([]), `any`, false, false, false), `Y-m-d`]), `html`, null, true]));
                this.echo(`">
            `);
                this.echo(this.env.getFilter('escape').traceableCallable(65, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(65, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 65, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `date`, new Map([]), `any`, false, false, false), `M j, Y`]), `html`, null, true]));
                this.echo(`
          </time>
          <span class="u-hidden-visually">
            `);
                if (this.traceableMethod(this.getAttribute, 68, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `is_child`, new Map([]), `any`, false, false, false)) {
                    this.echo(`reply`);
                }
                else {
                    this.echo(`comment`);
                }
                this.echo(`          </span>
        </a>
      </div>
      `);
                if ((context.has(`source`) ? context.get(`source`) : null)) {
                    this.echo(`        <div class="c-comment__meta-detail">
          via <a class="c-comment__meta-link" href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(74, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 74, this.source)(this.env, (context.has(`source`) ? context.get(`source`) : null), `url`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(74, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 74, this.source)(this.env, (context.has(`source`) ? context.get(`source`) : null), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</a>
        </div>
      `);
                }
                this.echo(`
      `);
                if ((context.has(`allow_replies`) ? context.get(`allow_replies`) : null)) {
                    this.echo(`        <div class="c-comment__meta-control">
          `);
                    this.echo(`          `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`type`, `button`], [`class`, `c-button--tertiary js-comment-reply-button`], [`content_start_icon`, `speech-balloon`], [`label`, `Reply`]]), false, false, 85));
                    this.echo(`        </div>
      `);
                }
                this.echo(`    </div>
    `);
                context.proxy[`_section_heading_depth`] = this.env.getFunction('min').traceableCallable(94, this.source)(...[((context.has(`_heading_depth`) ? context.get(`_heading_depth`) : null) + 1), 6]);
                this.echo(`
    `);
                if ((context.has(`allow_replies`) ? context.get(`allow_replies`) : null)) {
                    this.echo(`      `);
                    this.echo(`      `);
                    this.startOutputBuffer();
                    this.echo(`        `);
                    this.traceableDisplayBlock(102, this.source)('reply_form_hidden_inputs', context.clone(), blocks);
                    this.echo(`      `);
                    context.proxy[`reply_form_hidden_inputs_content`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                    this.echo(`
      <div class="c-comment__reply-form js-comment-reply-form">
        `);
                    this.traceableDisplayBlock(106, this.source)('reply_form', context.clone(), blocks);
                    this.echo(`      </div>
    `);
                }
                this.echo(`    `);
                if ( !this.env.getTest('empty').traceableCallable(128, this.source)(...[this.traceableMethod(this.getAttribute, 128, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `children`, new Map([]), `any`, false, false, false)])) {
                    this.echo(`      `);
                    context.proxy[`_child_heading_depth`] = this.env.getFunction('min').traceableCallable(129, this.source)(...[((context.has(`_section_heading_depth`) ? context.get(`_section_heading_depth`) : null) + 1), 6]);
                    this.echo(`      <h`);
                    this.echo(this.env.getFilter('escape').traceableCallable(130, this.source)(...[this.env, (context.has(`_section_heading_depth`) ? context.get(`_section_heading_depth`) : null), `html`, null, true]));
                    this.echo(` class="u-hidden-visually">
        Replies to `);
                    this.echo(this.env.getFilter('escape').traceableCallable(131, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 131, this.source)(this.env, this.traceableMethod(this.getAttribute, 131, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `author`, new Map([]), `any`, false, false, false), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
      </h`);
                    this.echo(this.env.getFilter('escape').traceableCallable(132, this.source)(...[this.env, (context.has(`_section_heading_depth`) ? context.get(`_section_heading_depth`) : null), `html`, null, true]));
                    this.echo(`>

      `);
                    this.echo(`      `);
                    this.startOutputBuffer();
                    this.echo(`        `);
                    this.traceableDisplayBlock(139, this.source)('replies', context.clone(), blocks);
                    this.echo(`      `);
                    context.proxy[`repliesContent`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                    this.echo(`
      `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, 149, 122), new Map([[`class`, `c-comment__replies`]]), true, false, 149));
                    this.echo(`    `);
                }
                this.echo(`  </footer>
</article>
`);
            }

            block_header_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      <h`);
                this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, (context.has(`_heading_depth`) ? context.get(`_heading_depth`) : null), `html`, null, true]));
                this.echo(` class="c-comment__heading" id="comment-heading-`);
                this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 19, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `ID`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`">
        `);
                this.traceableDisplayBlock(20, this.source)('heading_content', context.clone(), blocks);
                this.echo(`      </h`);
                this.echo(this.env.getFilter('escape').traceableCallable(29, this.source)(...[this.env, (context.has(`_heading_depth`) ? context.get(`_heading_depth`) : null), `html`, null, true]));
                this.echo(`>
    `);
            }

            block_heading_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.traceableDisplayBlock(21, this.source)('author_title', context.clone(), blocks);
                this.echo(`
          <span class="u-hidden-visually">
            `);
                if (this.traceableMethod(this.getAttribute, 26, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `is_child`, new Map([]), `any`, false, false, false)) {
                    this.echo(`replied`);
                }
                else {
                    this.echo(`said`);
                }
                this.echo(`:
          </span>
        `);
            }

            block_author_title(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.env.getFilter('escape').traceableCallable(22, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 22, this.source)(this.env, this.traceableMethod(this.getAttribute, 22, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `author`, new Map([]), `any`, false, false, false), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`
          `);
            }

            block_reply_form_hidden_inputs(context, blocks = new Map()) {
                let macros = this.macros.clone();
            }

            block_reply_form(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, 107, 121), new Map([[`is_reply`, true], [`logged_in_user`, (context.has(`logged_in_user`) ? context.get(`logged_in_user`) : null)], [`log_out_url`, (context.has(`log_out_url`) ? context.get(`log_out_url`) : null)], [`heading_id`, (`reply-to-comment-` + this.traceableMethod(this.getAttribute, 111, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `ID`, new Map([]), `any`, false, false, false))], [`help_text_id`, ((`reply-to-comment-` + this.traceableMethod(this.getAttribute, 112, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `ID`, new Map([]), `any`, false, false, false)) + `-help-text`)], [`heading_tag`, (`h` + (context.has(`_section_heading_depth`) ? context.get(`_section_heading_depth`) : null))], [`heading_text`, (`Reply to ` + this.traceableMethod(this.getAttribute, 114, this.source)(this.env, this.traceableMethod(this.getAttribute, 114, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `author`, new Map([]), `any`, false, false, false), `name`, new Map([]), `any`, false, false, false))], [`heading_class`, `u-hidden-visually`], [`main_label`, `Reply`], [`action`, (context.has(`reply_form_action`) ? context.get(`reply_form_action`) : null)], [`method`, (context.has(`reply_form_method`) ? context.get(`reply_form_method`) : null)], [`reply_form_hidden_inputs_content`, (context.has(`reply_form_hidden_inputs_content`) ? context.get(`reply_form_hidden_inputs_content`) : null)]]), false, false, 107));
                this.echo(`        `);
            }

            block_replies(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 140, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `children`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`child`] = __value__;
                    this.echo(`            `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/comment/comment.twig`, new Map([[`comment`, context.get(`child`)], [`heading_depth`, (context.has(`_child_heading_depth`) ? context.get(`_child_heading_depth`) : null)]]), false, false, 141));
                    this.echo(`          `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('child');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`        `);
            }

            getTemplateName() {
                return `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, ``);
            }
        }],
        [120, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, 38);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                if ( !this.traceableMethod(this.getAttribute, 42, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `approved`, new Map([]), `any`, false, false, false)) {
                    this.echo(`        `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/alert/alert.twig`, new Map([[`message`, `This comment is awaiting moderation.`]]), false, false, 43));
                    this.echo(`      `);
                }
                this.echo(`      `);
                this.echo(this.traceableMethod(this.getAttribute, 47, this.source)(this.env, (context.has(`comment`) ? context.get(`comment`) : null), `comment_content`, new Map([]), `any`, false, false, false));
                this.echo(`
    `);
            }

            getTemplateName() {
                return `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, ``);
            }
        }],
        [121, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/comment-form/comment-form.twig`, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, 107);

                this.blocks = new Map([
                    ['hidden_inputs', [this, 'block_hidden_inputs']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/comment-form/comment-form.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_hidden_inputs(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                this.echo(this.env.getFilter('escape').traceableCallable(122, this.source)(...[this.env, (context.has(`reply_form_hidden_inputs_content`) ? context.get(`reply_form_hidden_inputs_content`) : null), `html`, null, true]));
                this.echo(`
            `);
            }

            getTemplateName() {
                return `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, ``);
            }
        }],
        [122, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, 149);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.env.getFilter('escape').traceableCallable(153, this.source)(...[this.env, (context.has(`repliesContent`) ? context.get(`repliesContent`) : null), `html`, null, true]));
                this.echo(`
        `);
            }

            getTemplateName() {
                return `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3');

let template = env.loadTemplate('c19e70194283b279f8064315a7809d2c9ebcc230a09da0d06a20981c4fdb3fe3');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/comment/comment.twig", args: context }
     );
     return rendered;;
};